export const availableLanguages = { ru: "Ru", en: "En" };
